"use client"
/* */
const accordion = "flow--accordion";
const header = "flow--accordion--header";
const headerButton = "flow--accordion--header-button";
const content = "flow--accordion--content";
const contentInner = "flow--accordion--content-inner";
const chevron = "flow--accordion--chevron";
const outline = "flow--accordion--outline";
const expanded = "flow--accordion--expanded";
const styles = {
	accordion: accordion,
	header: header,
	headerButton: headerButton,
	content: content,
	contentInner: contentInner,
	chevron: chevron,
	outline: outline,
	expanded: expanded
};

export { accordion, chevron, content, contentInner, styles as default, expanded, header, headerButton, outline };
//# sourceMappingURL=Accordion.module.scss.mjs.map
